import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import { css } from 'styled-components'

export default css`
  display: grid;
  grid-template-columns: 40% 60%;

  // Hide the CMS on smaller screens
  @media (max-width: 768px) {
    grid-template-columns: 1fr;

    & > *:first-child {
      display: none;
    }
  }
`

export const mobilePopupStyle = css`
  display: none;
  ${getBreakpointDown(breakpointSizes.XSM)(css`
    display: block;
  `)}
`
